import { Injectable } from "@angular/core";
import { IID_OL_CHECKLIST } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolChecklistStore } from "./iidOlChecklist.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
    providedIn: 'root'
  })
  @InterfaceDataQuery(InterfaceName.CHECKLIST)
  export class IIDolChecklistQuery extends AbstractInterfaceDataQuery<IID_OL_CHECKLIST> {
  
    constructor(protected store: IIDolChecklistStore) {
      super(store);
    }
  }